import { FC, useState } from 'react';
import styled, { css } from 'styled-components';

import { parseHTML } from '@/lib/parse';

const Faq: FC<any> = ({ data }) => {
	const [itemActive, setItemActive] = useState<number | null>(null);

	const toggleBlock = (index: number) => {
		const collapsibles: any = Array.from(
			document.querySelectorAll('.faq-collapsible'),
		);

		setItemActive(itemActive === index ? null : index);

		collapsibles?.forEach((item) => {
			item.style.opacity = 0;
			item.style.maxHeight = 0;
		});

		collapsibles[index].style.opacity = itemActive === index ? 0 : 1;
		collapsibles[index].style.maxHeight =
			itemActive === index ? 0 : collapsibles[index].scrollHeight + 'px';
	};

	return (
		<Container>
			{data?.map((item, index: number) => (
				<Block
					key={`faq_item_${index}`}
					$active={itemActive === index}
					onClick={() => toggleBlock(index)}
				>
					<Question>{item.question}</Question>

					<Collapsible className="faq-collapsible">
						{item.answerRich ? (
							<Answer>{parseHTML(item.answerRich)}</Answer>
						) : null}

						{item.note ? <Note>{item.note}</Note> : null}
					</Collapsible>
				</Block>
			))}
		</Container>
	);
};

const Container = styled.div`
	max-width: 100%;
	width: 960px;
	margin: 120px auto 60px;
	display: flex;
	flex-direction: column;
	row-gap: 12px;

	@media (max-width: 767px) {
		margin: 60px auto;
	}
`;

const Block = styled.div<{ $active: boolean }>`
	font-family: var(--font-sans);
	padding: 40px 172px 40px 48px;
	background-color: rgb(205, 201, 227, 0.2);
	border-radius: 50px;
	user-select: none;
	position: relative;
	cursor: pointer;
	overflow: hidden;
	transition-duration: 0.5s;

	@media (max-width: 767px) {
		padding: 30px 50px 30px 30px;
	}

	&:before {
		content: '';
		position: absolute;
		top: 53px;
		right: 48px;
		width: 18px;
		height: 11px;
		background: url(/images/faq/arrow.svg) no-repeat center/contain;
		transition-duration: 0.5s;

		@media (max-width: 767px) {
			top: 37px;
			right: 30px;
		}
	}

	${({ $active }) =>
		$active &&
		css`
			&:before {
				transform: rotate(180deg);
			}
		`}
`;

const Question = styled.div`
	font-size: 28px;
	line-height: 125%;
	color: var(--color-purple);

	@media (max-width: 767px) {
		font-size: 20px;
	}
`;

const Collapsible = styled.div`
	opacity: 0;
	max-height: 0;
	transition-duration: 0.25s;
`;

const Answer = styled.div`
	font-size: 18px;
	line-height: 139%;
	color: var(--color-black);
	padding-top: 16px;

	a {
		color: var(--color-purple);
		text-decoration: none;
	}

	i {
		font-style: italic;
	}

	strong {
		font-weight: var(--font-bold);
	}

	@media (max-width: 767px) {
		font-size: 14px;
	}
`;

const Note = styled.div`
	font-weight: var(--font-medium);
	font-size: 14px;
	line-height: 143%;
	color: var(--color-purple-50);
	padding-top: 24px;

	@media (max-width: 767px) {
		padding-top: 16px;
		font-size: 12px;
	}
`;

export default Faq;
